import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import styles from './FormGroup.module.css';
export type FormGroupProps = PropsWithChildren<Record<never, never>>;
export const FormGroup: FunctionComponent<FormGroupProps> = React.memo(props => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
  } else {
    children = $[3];
    remainingProps = $[4];
  }
  let t1;
  if ($[5] !== children || $[6] !== remainingProps) {
    t1 = <div {...remainingProps} className={styles.formGroup}>{children}</div>;
    $[5] = children;
    $[6] = remainingProps;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
});